export default "/images/sidebar-background.svg";